import {makeRequest} from '../../api/client'

const apiClient = require('@/api/client.js')

export default {

  getAutoComplete(term) {
    // Ld website api key
    return makeRequest('GET', '/location/autocomplete', { input: term }, {'x-api-key': '899deca0ca2e6763d8068c756a8f575d'}, function(){});
  }

}



// WEBPACK FOOTER //
// ./src/components/location/service.js